import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import ReactDom from 'react-dom';
import {createSelector} from 'reselect';
import {push} from 'react-router-redux';
import queryString from 'query-string';

import * as styles from '../../styles';
import Tree from '../tree';
import {setSelectedItems, removeItemSelection} from '../tree/actions';
import {request} from '../../containers/actions';
import {refresh as paginatorRefresh} from '../../paginator/actions';
import PaginatedContainer from '../../paginator/paginated_container';
import QuestionDialog from './question_dialog';
import * as actions from './actions';
import exportToWord from '../../utilities/docs';

export default class Questions extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: true,
        actions: [],
        buttonActions: [],
    }

    style = {items: {itemsList: {width: 'auto', overflowX: 'auto'}}}

    listFields = [
        {field: 'id', label: window.gettext('ID')},
        {
            field: item => {
                const renderer = document.createElement('div');
                renderer.innerHTML = item.content;
                let questionContent = renderer.innerText;
                if (item.fake)
                    questionContent = '--- ' + window.gettext('Fake') + ' ---';
                if (item.index !== undefined) {
                    questionContent = `${(item.index + 1).persian()}. ` +
                        questionContent;
                }
                return <div
                    key={item.id}
                    style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        width: '25em',
                    }}>
                    {questionContent}
                </div>;
            },
            label: window.gettext('Question'),
        },
        {
            field: item => window.pgettext('question', 'question-Status-' + item.status),
            label: window.gettext('Status'),
        },
        {
            // field: item => _.filter(_.map(Array(4), (__, index) => Math.log2(item.key & 1 << index)), option => option > 0).join(window.gettext(',') + ' ').persian(),
            field: item => item.key == 0 ? '' : item.key == 4 ? '۳' : (item.key == 8 ? '۴' : item.key.persian()),
            label: window.gettext('Option'),
        },
        {
            field: item => <span>
                {_.map(
                    item.subjects,
                    subject => <div key={subject.id} style={styles.tag}>
                        {_.concat(subject.parent_material, subject.title).join(' ← ').persian()}
                    </div>,
                )}
            </span>,
            label: window.gettext('Subjects'),
        },
        {
            field: item => <span>
                {_.map(
                    item.labels,
                    label => <div key={label.id} style={styles.tag}>
                        {_.concat(label.parents, label.title).join(' ← ').persian()}
                    </div>,
                )}
            </span>,
            label: window.gettext('Labels'),
        },
        {
            field: item => item.question_type ? item.question_type.title : '',
            label: window.gettext('Type'),
        },
        {
            field: item => item.level ? item.level.title : '',
            label: window.gettext('Level'),
        },
        {
            field: item =>
            <span>
                {_.map(
                    item.grades,
                    grade => <div key={grade.id} style={styles.tag}>
                        {grade.title.persian()}
                    </div>,
                )}
            </span>, 
            label: window.gettext('Grade'),
        },
    ]

    filtersSelector = createSelector.bind(this)(
        [
            () => this.props.store.getIn(['materialsTreeFilter']),
            () => this.props.store.getIn(['subjectsTreeFilter']),
            () => this.props.store.getIn(['labelsTreeFilter']),
            () => this.props.store.getIn(['typesTreeFilter']),
            () => this.props.store.getIn(['levelsTreeFilter']),
            () => this.props.store.getIn(['gradesTreeFilter']),
            () => this.props.store.getIn(['statusesTreeFilter']),
        ],
        () => [
            {
                field: 'fake',
                selected: {'False': null},
            },
            {
                field: 'materials',
                label: window.gettext('Material'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('materialsTreeFilter')}
                        header
                        readonly
                        resource='material'
                        label={window.gettext('Material')}
                    />
                </div>,
                selected: this.props.store.getIn(['materialsTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'material',
                    this.props.store.getIn(['materialsTreeFilter', 'elementId']),
                )),
            },
            {
                field: 'subjects',
                label: window.gettext('Subjects Tree'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('subjectsTreeFilter')}
                        tree
                        header
                        readonly
                        resource='subject'
                        itemLabel={this.subjectItemLabel}
                        filter={{
                            material: this.props.store.getIn(['materialsTreeFilter', 'selected']).keySeq().join(',') || -1,
                        }}
                        label={window.gettext('Subjects Tree')}
                    />
                </div>,
                selected: this.props.store.getIn(['subjectsTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'subject',
                    this.props.store.getIn(['subjectsTreeFilter', 'elementId']),
                )),
            },
            {
                field: 'labels',
                label: window.gettext('Labels Tree'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('labelsTreeFilter')}
                        tree
                        header
                        readonly
                        resource='question-label'
                        label={window.gettext('Labels Tree')}
                    />
                </div>,
                selected: this.props.store.getIn(['labelsTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'question-label',
                    this.props.store.getIn(['labelsTreeFilter', 'elementId']),
                )),
            },
            {
                field: 'question_type',
                label: window.gettext('Type'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('typesTreeFilter')}
                        header
                        readonly
                        resource='question-type'
                        label={window.gettext('Type')}
                    />
                </div>,
                selected: this.props.store.getIn(['typesTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'question-type',
                    this.props.store.getIn(['typesTreeFilter', 'elementId']),
                )),
            },
            {
                field: 'level',
                label: window.gettext('Level'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('levelsTreeFilter')}
                        readonly
                        header
                        resource='question-level'
                        label={window.gettext('Level')}
                    />
                </div>,
                selected: this.props.store.getIn(['levelsTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'question-level',
                    this.props.store.getIn(['levelsTreeFilter', 'elementId']),
                )),
            },
            {
                field: 'grades',
                label: window.gettext('Grade'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('gradesTreeFilter')}
                        readonly
                        header
                        resource='grade'
                        label={window.gettext('Grade')}
                    />
                </div>,
                selected: this.props.store.getIn(['gradesTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'grade',
                    this.props.store.getIn(['gradesTreeFilter', 'elementId']),
                )),
            },
            {
                field: 'status',
                label: window.gettext('Status'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('statusesTreeFilter')}
                        readonly
                        header
                        resource='question-Status'
                        label={window.gettext('Status')}
                        staticItems={_.mapValues(
                            _.mapKeys(Array(5), (__, index) => Number(index) + 1),
                            (__, index) => ({id: index, label: window.pgettext('question', 'question-Status' + index)}),
                        )}
                    />
                </div>,
                selected: this.props.store.getIn(['statusesTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'question-status',
                    this.props.store.getIn(['statusesTreeFilter', 'elementId']),
                )),
            },
        ],
    )

    sorts = [
        {name: 'id', label: window.gettext('ID'), reversed: true},
    ]

    actionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
            () => this.props.store.getIn(['paginator', 'selected']).size > 0,
        ],
        () => this.props.readonly
            ? this.props.actions
            : _.concat(
                this.props.actions,
                this.props.store.getIn(['paginator', 'selected']).size > 0
                    ? [
                        {
                            label: window.gettext('Duplicate'),
                            action: async () => {
                                if (!window.confirm(window.interpolate(
                                    window.gettext('Are you sure you wanna duplicate these %(count)s questions?'),
                                    {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                    true,
                                )))
                                    return;
                                await this.context.store.dispatch(request({
                                    path: '/question/duplicate/',
                                    body: {
                                        id: this.props.store.getIn(['paginator', 'selected']).keySeq(),
                                    },
                                    method: 'POST',
                                }));
                                this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
                            },
                        },
                        {
                            label: window.gettext('Remove'),
                            action: async () => {
                                if (!window.confirm(window.interpolate(
                                    window.gettext('Are you sure you wanna remove these %(count)s questions?'),
                                    {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                    true,
                                )))
                                    return;
                                await this.context.store.dispatch(request({
                                    path: '/question/?' + queryString.stringify({
                                        id: this.props.store.getIn(['paginator', 'selected']).keySeq().join(','),
                                    }),
                                    method: 'DELETE',
                                }));
                                this.context.store.dispatch([
                                    ..._.map(
                                        this.props.store.getIn(['paginator', 'selected']).keySeq().toArray(),
                                        id => actions.removeQuestion(
                                            id,
                                            this.props.store.getIn(['main', 'elementId']),
                                        ),
                                    ),
                                    paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                                ]);
                            },
                        },
                        {
                            label: window.gettext('Mass Edit'),
                            action: () => this.context.store.dispatch(push(
                                this.context.store.getState().getIn(
                                    ['routing', 'locationBeforeTransitions', 'pathname'],
                                ) + this.props.store.getIn(['paginator', 'selected']).keySeq().join(',') + '/',
                            )),
                        },
                        {
                            label: window.gettext('Designer Form'),
                            action: () => {
                                const win = this.refs.print.contentWindow;
                                try {
                                    const teamLeaderName = prompt(window.gettext('Enter team leader name:')).persian();
                                    const examinationName = prompt(window.gettext('Enter examination name:')).persian();
                                    const examinationBudget = prompt(window.gettext('Enter examination budget:')).persian();
                                    const material = prompt(window.gettext('Enter material:')).persian();
                                    const exportType = prompt(window.gettext('نوع خروجی مد نظر وارد کنید : (1 پی دی اف و 2 ورد)'));
                                    const generalStyle = {
                                        border: '.125em solid black',
                                        padding: '2mm',
                                        verticalAlign: 'top',
                                        width: '25%',
                                    };
                                    ReactDom.unmountComponentAtNode(win.document.getElementById('content'));
                                    ReactDom.render(<div style={{pageBreakAfter:'always'}}>
                                        {_.map(
                                            this.props.store.getIn(['paginator', 'selected']).toJS(),
                                            question => {
                                                return <table
                                                    key={question.id}
                                                    style={{
                                                        position:"relative",
                                                        height: exportType == 1 ? '272mm' : '262mm',
                                                        width: exportType == 1 ? '189mm' : '179mm',
                                                        overflow: 'hidden',
                                                        pageBreakAfter: 'always',
                                                        margin: exportType == 1 ? '1cm' : '0cm',
                                                        marginBottom: exportType == 1 ? '0cm' : '1cm',
                                                        borderCollapse: 'collapse',
                                                        textAlign: 'right',
                                                    }}>
                                                    <tbody>
                                                    <div style={{position:"absolute" , width:"100%" , height:"100%" , display:"flex" , justifyContent:"center" , alignItems:"center" , top:0 , left:0 , zIndex:"-1"}}>
                                                        <img src="https://api.mhelli.com/image/a639ebb81a114b8ea03901ffbeccf9d5/500/-/contain" style={{width:"500px" , height:"500px", opacity:"0.1"}} />
                                                    </div>
                                                        <tr>
                                                            <td
                                                                colSpan={4}
                                                                style={{...generalStyle, textAlign: 'center', padding: undefined, width: undefined}}>
                                                                {window.gettext('Question ID')}: {question.id.persian()}
                                                                <div style={{float: 'left'}}>
                                                                &nbsp;آ&nbsp;&nbsp;ب&nbsp;&nbsp;ج&nbsp;&nbsp;د&nbsp;
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={generalStyle}>
                                                                {window.gettext('Team leader\'s Name')}: {teamLeaderName}
                                                            </td>
                                                            <td style={generalStyle}>
                                                                {window.gettext('Designer\'s Name')}:
                                                            </td>
                                                            <td style={generalStyle}>
                                                            &#9744;{window.gettext('Designedly')}&nbsp;
                                                            &#9744;{window.gettext('Selectively')}
                                                            </td>
                                                            <td style={generalStyle}>
                                                                {window.gettext('Question Type')}:
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={generalStyle}>
                                                                {window.gettext('Grade')}: {_.map(question.grades, 'title').join(window.gettext(',') + ' ')}
                                                            </td>
                                                            <td style={generalStyle}>
                                                                {window.gettext('Editor\'s Name')}:
                                                            </td>
                                                            <td style={{...generalStyle, fontSize: '1em'}}>
                                                            &#9744;{window.gettext('Sampad')}&nbsp;
                                                            &#9744;{window.gettext('Baakhe')}&nbsp;
                                                            &#9744;{window.gettext('Common')}
                                                            </td>
                                                            <td style={{...generalStyle, fontSize: '1em'}}>
                                                            &#9744;{window.gettext('Easy')}&nbsp;
                                                            &#9744;{window.gettext('Medium')}&nbsp;
                                                            &#9744;{window.gettext('Hard')}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={generalStyle}>
                                                                {window.gettext('Material')}:&nbsp;
                                                                {material || _.uniq(_.map(question.subjects, 'parent_material')).join(window.gettext(',') + ' ')}
                                                            </td>
                                                            <td style={generalStyle}>
                                                                {window.gettext('Examination Name')}: {examinationName}
                                                            </td>
                                                            <td rowSpan={2} style={generalStyle}>
                                                                {window.gettext('Examination Budget')}: {examinationBudget}
                                                            </td>
                                                            <td style={generalStyle}>
                                                                {window.gettext('Page in book')}:
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={generalStyle}>
                                                                {window.gettext('Subject')}: {_.uniq(_.map(question.subjects, 'title')).join(window.gettext(',') + ' ')}
                                                            </td>
                                                            <td style={generalStyle}>
                                                                {window.gettext('Question Index in Examination')}:
                                                            </td>
                                                            <td style={generalStyle}>
                                                                {window.gettext('Description')}:
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan={4} style={{...generalStyle, height: '11cm', textAlign: undefined, width: undefined}}>
                                                                {window.gettext('Question')}:
                                                                <span
                                                                    style={styles.content}
                                                                    dangerouslySetInnerHTML={{__html: question.content}}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr style={{height: '100%'}}>
                                                            <td colSpan={4} style={{...generalStyle, textAlign: undefined, width: undefined}}>
                                                                {window.gettext('Answer')}:
                                                                <span
                                                                    style={styles.content}
                                                                    dangerouslySetInnerHTML={{__html: question.answer}}
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>;
                                            },
                                        )}
                                    </div>, win.document.getElementById('content'));
                                    if(exportType == 1){
                                        win.print();
                                    }
                                    if(exportType == 2){
                                        const html = win.document.getElementById('content').innerHTML;
                                        exportToWord(html,teamLeaderName + '-' + examinationName + '-' + material);
                                    }
                                }
                                catch (exception) {
                                }
                            },
                        },
                    ]
                    : [],
            ),
    )

    buttonActionsSelector = createSelector(
        [
            () => this.props.buttonActions,
            () => this.props.readonly,
        ],
        () => this.props.readonly
            ? this.props.buttonActions
            : _.concat(this.props.buttonActions, [
                {
                    label: window.gettext('New Question'),
                    action: async () => {
                        await this.context.store.dispatch([
                            setSelectedItems(
                                this.props.store.getIn(['materialsTreeFilter', 'selected']).keySeq().toArray(),
                                'material',
                                this.props.store.getIn(['questionDialog', 'materialsTree', 'elementId']),
                            ),
                            setSelectedItems(
                                this.props.store.getIn(['subjectsTreeFilter', 'selected']).keySeq().toArray(),
                                'subject',
                                this.props.store.getIn(['questionDialog', 'subjectsTree', 'elementId']),
                            ),
                            setSelectedItems(
                                this.props.store.getIn(['labelsTreeFilter', 'selected']).keySeq().toArray(),
                                'question-label',
                                this.props.store.getIn(['questionDialog', 'labelsTree', 'elementId']),
                            ),
                            setSelectedItems(
                                this.props.store.getIn(['typesTreeFilter', 'selected']).keySeq().toArray(),
                                'question-type',
                                this.props.store.getIn(['questionDialog', 'typesTree', 'elementId']),
                            ),
                            setSelectedItems(
                                this.props.store.getIn(['levelsTreeFilter', 'selected']).keySeq().toArray(),
                                'question-level',
                                this.props.store.getIn(['questionDialog', 'levelsTree', 'elementId']),
                            ),
                            setSelectedItems(
                                this.props.store.getIn(['statusesTreeFilter', 'selected']).keySeq().toArray(),
                                'question-status',
                                this.props.store.getIn(['questionDialog', 'statusesTree', 'elementId']),
                            ),
                            setSelectedItems(
                                this.props.store.getIn(['gradesTreeFilter', 'selected']).map((__, gradeId) =>
                                    this.context.store.getState().getIn(['trees', 'items', 'grade:limit=100000', gradeId, 'level', 'id'])).toArray(),
                                'level',
                                this.props.store.getIn(['questionDialog', 'levelsTree', 'elementId']),
                            ),
                            setSelectedItems(
                                this.props.store.getIn(['gradesTreeFilter', 'selected']).keySeq().toArray(),
                                'grade',
                                this.props.store.getIn(['questionDialog', 'gradesTree', 'elementId']),
                            ),
                            push(this.context.store.getState().getIn(
                                ['routing', 'locationBeforeTransitions', 'pathname'],
                            ) + '0/'),
                        ]);
                    },
                },
                {
                    label: window.gettext('Add Multiple Questions'),
                    action: async () => {
                        const number = prompt(window.gettext('Enter number of questions you want to create:'));
                        if (!number)
                            return;
                        await this.context.store.dispatch(request({
                            path: '/question/',
                            body: _.map(Array(Number.parseInt(number)), () => ({
                                content: '',
                                answer: '',
                                level: null,
                                subjects: this.props.store.getIn(['subjectsTreeFilter', 'selected']).map((__, key) => ({id: key})).toArray(),
                                labels: this.props.store.getIn(['labelsTreeFilter', 'selected']).map((__, key) => ({id: key})).toArray(),
                                'question_type': this.props.store.getIn(['typesTreeFilter', 'selected']).size
                                    ? {id: this.props.store.getIn(['typesTreeFilter', 'selected']).keySeq().first()}
                                    : null,
                                level: this.props.store.getIn(['levelsTreeFilter', 'selected']).size
                                    ? {id: this.props.store.getIn(['levelsTreeFilter', 'selected']).keySeq().first()}
                                    : null,
                                grades: _.map(this.props.store.getIn(['gradesTreeFilter', 'selected']).toJS(), (__, key) => ({id: key})),
                                gzip: true
                            })),
                            method: 'POST',
                        }, this.props.store.getIn(['main', 'elementId'])));
                        this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
                    },
                },
            ]),
    )

    constructor(props) {
        super(props);
        this.tooltip = this.tooltip.bind(this);
        this.refresh = this.refresh.bind(this);
        this.closeQuestion = this.closeQuestion.bind(this);
    }

    tooltip(item) {
        return (item.note || '').persian();
    }

    refresh() {
        this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
    }

    closeQuestion() {
        const path = this.context.store.getState().getIn(['routing', 'locationBeforeTransitions', 'pathname']);
        this.context.store.dispatch(push(path.split('/').slice(0, -2).join('/') + '/'));
    }

    subjectItemLabel(subject) {
        return `${subject.parent_material} - ${subject.title}`;
    }

    render() {
        const id = this.props.id || (this.props.params ? this.props.params.id : undefined) || '';
        return <span style={{backgroundColor: 'inherit'}}>
            <PaginatedContainer
                store={this.props.store.get('paginator')}
                resource='question'
                style={this.style}
                fixedColumns={2}
                listFields={this.listFields}
                tooltip={this.tooltip}
                title={window.gettext('Questions Bank')}
                removable
                selectable={this.props.selectable}
                filters={this.filtersSelector(this.props.store)}
                sorts={this.sorts}
                pageSize={this.props.pageSize}
                active={id.match(/,/) ? id : undefined}
                actions={this.actionsSelector(this.props.store)}
                buttonActions={this.buttonActionsSelector(this.props.store)}
            />
            <QuestionDialog
                store={this.props.store.get('questionDialog')}
                id={id.match(/,/) ? undefined : id}
                onUpdate={this.refresh}
                onClose={this.closeQuestion}
            />
            <iframe
                ref='print'
                style={{width: '0', height: '0', border: 'none'}}
                srcDoc={`<html>
    <head>
        <link rel="stylesheet" type="text/css" href="/css/mhelli.css">
        <link rel="stylesheet" type="text/css" href="/css/mathjax.css">
        <style>
            @page {
                size: A4 Portrait;
                margin: 0;
            }
            html, body {
                font-family: IRANSans;
                margin: 0;
                width : 210mm;
                height : 297mm;
                size: auto;
                direction: rtl;
            }
            @media print {
                div {
                    -webkit-print-color-adjust: exact;
                }
            }
        </style>
        <script type='text/javascript' src='https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?delayStartupUntil=configured'></script>
    </head>
    <body>
        <span id='content'><span>1</span><span style='font-weight: 700;'>2</span></span>
        <script type='text/javascript'>
            MathJax.Hub.Config({
                config: ['MMLorHTML.js'],
                jax: ['input/TeX','input/MathML','input/AsciiMath','output/HTML-CSS','output/NativeMML', 'output/PreviewHTML'],
                extensions: ['tex2jax.js','mml2jax.js','asciimath2jax.js', 'fast-preview.js', 'AssistiveMML.js'],
                TeX: {
                    extensions: [
                        'AMSmath.js',
                        'AMSsymbols.js',
                        'AMScd.js',
                        'noErrors.js',
                        'noUndefined.js',
                        'cancel.js',
                        'mhchem.js',
                        'autobold.js',
                    ],
                },
                'HTML-CSS': {
                    mtextFontInherit: true,
                },
                messageStyle: 'none',
                menuSettings: {
                    inTabOrder: false,
                    context: 'Browser',
                },
                processSectionDelay: 0,
                skipStartupTypeset: true,
            });
            MathJax.Hub.Configured();
        </script>
    </body>
</html>`}
            />
        </span>;
    }
}

window.pgettext('question', 'question-Status-1');
window.pgettext('question', 'question-Status-2');
window.pgettext('question', 'question-Status-3');
window.pgettext('question', 'question-Status-4');
window.pgettext('question', 'question-Status-5');
